export function NewsPage() {
   return <p>There is no news.</p>;
}
